{
  "nl": {
    "incognito": {
      "signedInAs": "Aangemeld als",
      "stop": "Beëindigen"
    }
  }
}
